<template>
    <div>
        <h5 id="services-title" class="section">
            Services and Teaching
        </h5>
        <el-card class="box-card" id="services">
            <p class="service_para">
              Reviewer: TACCESS, MobileHCI'26, CHI'26, ICCV'25 workshop, CSCW'25 poster, IMWUT'24, ISMAR'24, SIGGRAPH'24 poster, CHI'24 LBW
            <!-- Reviewer: IMWUT'24, ISMAR'24, SIGGRAPH'24 poster, CHI'24 LBW -->
            </p>
            <el-divider></el-divider>
            <p class="service_para">
              Student volunteer: CHI'25
            </p>
            <el-divider></el-divider>
            <p class="research">
            Teaching Assistant for CS571 (Building User Interfaces) | University of Wisconsin-Madison
            </p>
            <p class="research-time">
            August 2024 -- May 2025, August 2023 -- December 2023
            </p>
        </el-card>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ServicesSection',
    data() {
      return {
      };
    }
  };
  </script>
  
  <style>
  </style>